const mutations = {
    setList(state, list) {
        state.itens = list;
    }
};

export default mutations;